import {
  Component,
  inject,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { AccordionComponent } from '../../../shared/components/accordion/accordion.component';
import { ListTableComponent } from '../../../shared/components/list-table/list-table.component';
import { ButtonComponent } from '../../../shared/components/button/button.component';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { NzFormModule } from 'ng-zorro-antd/form';
import { LeadDetailsService } from '../../../services/lead-details.service';
import { UserService } from '../../../services/user.service';
import {
  DialogConfig,
  DialogService,
} from '../../../shared/services/dialog.service';
import { HttpResponse } from '@angular/common/http';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { DateTimeFormatterService } from '../../../shared/utils/date-time-formatter.service';
import { STATIC_DATA } from '../../../shared/constants/static-data.constants';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { AuthorizationUtility } from '../../../shared/authorization/auth.utility';
import { MEMBER_VIEW_PAGE_IDS, TABS } from '../../../shared/constants/page.constants';
import { AuthorizeDirective } from '../../../shared/authorization/authorize.directive.';
import { TableRowActionsModel } from '../../../shared/interfaces/list.interface';
import { TableRowActions } from '../../../shared/interfaces/actions';

@Component({
  selector: 'ppl-tax-documents',
  standalone: true,
  imports: [
    AccordionComponent,
    ListTableComponent,
    ButtonComponent,
    NzRadioModule,
    FormsModule,
    ReactiveFormsModule,
    NzFormModule,
    NgxExtendedPdfViewerModule,
    NzCheckboxModule,
    AuthorizeDirective
  ],
  templateUrl: './tax-documents.component.html',
  styleUrl: './tax-documents.component.css',
})
export class TaxDocumentsComponent implements OnInit {
  taxDocsData: any[] = [];
  cols: any[] = [
    {
      field: 'formName',
      header: 'Tax Document Name',
      jsonpath: 'formName',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'year',
      header: 'Tax Year',
      jsonpath: 'year',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
  ];
  retirementDocsEligible = false;
  retirementDocsData: any[] = [];
  retirementDocsCols: any[] = [
    {
      field: 'label',
      header: 'File Name',
      jsonpath: 'label',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
  ];
  retirementDocsActions: TableRowActionsModel = new TableRowActions({ view: true, download: true });
  retirementHistoryData: any[] = [];
  retirementHistoryCols: any[] = [
    { field: 'documentLabel', header: 'Document Name', jsonpath: 'documentLabel', isDisplayedAtHeader: 'y', isSearchable: 'n' },
    { field: 'versionEffectiveDate', header: 'Version Effective Date', jsonpath: 'versionEffectiveDate', isDisplayedAtHeader: 'y', isSearchable: 'n' },
    { field: 'createdByName', header: 'Performed By', jsonpath: 'createdByName', isDisplayedAtHeader: 'y', isSearchable: 'n' },
    { field: 'createdDate', header: 'Event Date', jsonpath: 'createdDate', isDisplayedAtHeader: 'y', isSearchable: 'n' },
    { field: 'operation', header: 'Action Performed', jsonpath: 'operation', isDisplayedAtHeader: 'y', isSearchable: 'n' },
  ];
  taxDocumentForm!: FormGroup;
  disableSelection = true;
  mode = 'read';
  selectedLead: any;
  pdfSrc: any;
  programName: any;
  taxElection: any;
  taxAttrId: any;
  electionDate: any;
  selectedElectionValue: any;
  canEditPrintingElection = false;
  showCheckbox = false;
  CanViewPrintingElection = false;
  tabId = TABS.TaxDocuments;
  pageId = MEMBER_VIEW_PAGE_IDS[this.userService.getFirstSegment()!];
  @ViewChild('documentDialog') documentDialog!: TemplateRef<any>;
  @ViewChild('retirementHistoryDialog') retirementHistoryDialog!: TemplateRef<any>;
  private dialogSvc = inject(DialogService);

  actions = {
    view: true,
    download: true,
  };

  constructor(
    private fb: FormBuilder,
    private leadDetailsService: LeadDetailsService,
    private userService: UserService,
    private dateTimeFormatterService: DateTimeFormatterService,
    private authUtility: AuthorizationUtility
  ) {}

  ngOnInit(): void {
    const selectedProgram = this.userService.getSelectedProgram();
    this.programName = selectedProgram?.program_code ?? '';
    this.taxDocumentForm = this.fb.group({
      consent: [false],
      election: ['Y'],
    });

    this.selectedLead = JSON.parse(this.userService.getSelectedLead()!);
    this.getTaxDocData();
    this.getTaxElectionData();
    this.getRetirementPlanDocuments();
    this.canEditPrintingElection = !this.authUtility.isSectionEditable(this.pageId, this.tabId, 'CanEditPrintingElection');
    this.showCheckbox = !this.authUtility.isSectionEditable(this.pageId, this.tabId, 'canUpdatePrintingElection');
    this.CanViewPrintingElection = !this.authUtility.isSectionEditable(this.pageId, this.tabId, 'CanViewPrintingElection');
  }

  getTaxDocData() {
    this.leadDetailsService
      .getTaxDocumentsList(this.selectedLead)
      .subscribe((data: any) => {
        this.taxDocsData = data.responsedata;
      });
  }

  getTaxElectionData() {
    this.leadDetailsService
      .fetchLeadDetailsApi(
        STATIC_DATA.PROVIDER_ENROLLMENT,
        this.programName,
        this.selectedLead,
        false
      )
      .subscribe((data: any) => {
        const additionalAttributesData =
          data?.responsedata?.basicInfo?.additionalAttributes;
        const taxData = additionalAttributesData?.find(
          (data: any) => data?.additionalAttributesId === 110
        );
        this.taxElection = taxData;
        this.taxAttrId = this.taxElection?.providerAddtnlAttributesId;
        const date = new Date(this.taxElection?.effectiveFromDate);
        this.electionDate = !isNaN(date.getTime()) ? this.dateTimeFormatterService.formatDateToUSDateString(date) : '-';
        const value = this.taxElection?.value === 'N' ? 'N' : 'Y';
        this.taxDocumentForm.patchValue({ election: value });
        this.selectedElectionValue = value === 'Y' ? 'You are currently receiving a paper copy of your Year End Tax Documents':'You are currently not receiving a paper copy of your Year End Tax Documents';
      });
  }

  action(event: any) {
    if (event.action === 'view') {
      this.getDocument(event);
    }
    if (event.action === 'download') {
      this.leadDetailsService.downloadTaxDocument(event, this.selectedLead);
    }
  }

  getDocument(event: any) {
    this.leadDetailsService
      .viewTaxDocument(event.data.docId, this.selectedLead)
      .subscribe((response: HttpResponse<Blob>) => {
        if (response.body) {
          const blob = new Blob([response.body], { type: response.body.type });
          this.pdfSrc = window.URL.createObjectURL(blob);
          this.openDocumentDialog(event.data);
        }
      });
  }

  openDocumentDialog(data: any) {
    const dialogConfig: DialogConfig = {
      title: `${data.formName}-${data.year}`,
      size: 'x-large',
      position: 'top',
      showClose: true,
      showButtons: false,
    };

    this.dialogSvc.openDialog(
      this.documentDialog,
      dialogConfig,
      () => this.handleCancel(),
      () => this.handleCancel()
    );
  }

  handleCancel() {}

  get isRetirementHistoryRole(): boolean {
    return this.userService.isInRole(['PPL Admin', 'Compliance']);
  }

  getRetirementPlanDocuments() {
    this.leadDetailsService
      .getRetirementPlanDocuments(this.programName, this.selectedLead)
      .subscribe((data: any) => {
        this.retirementDocsEligible = !!data?.responsedata?.eligible;
        this.retirementDocsData = data?.responsedata?.documents ?? [];
      });
  }

  retirementDocAction(event: any) {
    if (event.action === 'view') {
      this.leadDetailsService
        .viewRetirementPlanDocument(this.programName, this.selectedLead, event.data.formsVersionId)
        .subscribe((response: HttpResponse<Blob>) => {
          if (response.body) {
            const blob = new Blob([response.body], { type: response.body.type });
            this.pdfSrc = window.URL.createObjectURL(blob);
            this.openDialog(this.documentDialog, event.data.label, 'x-large');
          }
        });
    }
    if (event.action === 'download') {
      this.leadDetailsService.downloadRetirementPlanDocument(this.programName, this.selectedLead, event.data);
    }
  }

  openRetirementHistory() {
    this.leadDetailsService
      .getRetirementPlanDocumentHistory(this.programName, this.selectedLead)
      .subscribe((data: any) => {
        this.retirementHistoryData = (data?.responsedata ?? []).map((item: { operation?: string; [key: string]: unknown }) => ({
          ...item,
          operation: item.operation ? item.operation.charAt(0).toUpperCase() + item.operation.slice(1).toLowerCase() : item.operation,
        }));
        this.openDialog(this.retirementHistoryDialog, 'Retirement Plan Document History', 'large');
      });
  }

  private openDialog(template: TemplateRef<any>, title: string, size: DialogConfig['size']) {
    const dialogConfig: DialogConfig = {
      title,
      size,
      position: 'top',
      showClose: true,
      showButtons: false,
    };
    this.dialogSvc.openDialog(template, dialogConfig, () => this.handleCancel(), () => this.handleCancel());
  }

  editDetails() {
    this.disableSelection = false;
    this.mode = 'edit';
  }

  saveDetails() {
    const payload = {
      id: this.selectedLead,
      enrollmentType: 'PRVDR',
      programCode: this.programName,
      attribute_id: this.taxAttrId || null,
      additional_attribute_id: 110,
      value: this.taxDocumentForm.value.election,
      effective_from_date:
        this.dateTimeFormatterService.formatDateToUSDateString(new Date()),
      effective_to_date: '12/31/2999',
    };
    this.leadDetailsService
      .saveUpdateAttribute(payload, 'taxDoc')
      .subscribe((data: any) => {
        this.getTaxElectionData();
        this.cancel();
      });
  }

  cancel() {
    this.disableSelection = true;
    this.mode = 'read';
  }
}
